<template>

	<div id="intro" class='container'>
		<div class="intro-wrap">
			<span class='intro-bar' ></span>
			<div class="intro-center img-hover1"  >
				<router-link to="/about" class=""><img src='img/half-face480.webp' alt='halfface' height="786px" width="541px"></router-link>
			</div>
			<div class="intro-left">	
				<h6>私</h6>
				<p>
					
					アバウト ACERCA de около TENTANG ТУХАЙ बारेमा ÜBER ZOKHUDZA À Propos کے بارے میں 
					เกี่ยวกับ ກ່ຽວກັບ ਬਾਰੇ பற்றி 关于 약 tungkol ТУРЫНДА  關於 trong khoảng
					<br><br>
					ACERCA de около  ТУХАЙ बारेमा ÜBER  À Propos کے بارے میں 
					เกี่ยวกับ ZOKHUDZA ກ່ຽວກັບ ਬਾਰੇ பற்றி 关于 khoảng TENTANG 약 TUNGKOL ТУРЫНДА  關於 trong  アバウト
					ਬਾਰੇ பற்றி 关于 약 약 ТУРЫНДА  關於 trong khoảng 
					<br><br>
					sHAK アバウト ABOUT
					
				</p>
			</div>
			<div class="intro-right">
				<p>アバウト ACERCA de около TENTANG ТУХАЙ बारेमा ÜBER ZOKHUDZA À Propos کے بارے میں 
					เกี่ยวกับ ກ່ຽວກັບ ਬਾਰੇ பற்றி 关于 약 tungkol ТУРЫНДА  關於 trong khoảng 
					tungkol ТУРЫНДА  關於 trong khoảng เกี่ยวกับ ກ່ຽວກັບ ਬਾਰੇ பற்றி 关于 khoảng
					<br><br>
					ТУХАЙ बारेमा ÜBER  À Propos کے بارے میں 
					ACERCA de около  ТУХАЙ बारेमा ÜBER  À Propos کے بارے میں 
					TENTANG 약 TUNGKOL ТУРЫНДА  關於 trong  アバウト
					ਬਾਰੇ பற்றி 关于 약 ТУХАЙ बारेमा ÜBER ZOKHUDZA À Propos
					<br><br>
					เกี่ยวกับ ກ່ຽວກັບ ਬਾਰੇ பற்றி
				</p>
			</div>
		</div>
	</div>
</template>

<script>


export default {
    name:"page-intro",

}
</script>